module.exports = __webpack_public_path__ + "img/x.d17658f4.png";